import inView from 'in-view';

export default function () {
  const selector = document.querySelectorAll('[data-whenvisible]');

  if (!selector.length) {
    return false;
  }

  [].forEach.call(selector, (function (elem, index) {
    const inViewFn = inView(`[data-whenvisible]:nth-child(${index + 1}n)`);
    const className = elem.dataset.whenvisible;

    if (!className) {
      return;
    }

    if (_isToggle(elem)) {
      inViewFn
        .on('enter', function () {
          addClass(elem, className);
        })
        .on('exit', function () {
          removeClass(elem, className);
        });
    } else {
      inViewFn
        .once('enter', function () {
          addClass(elem, className);
        });
    }
  }));

  /**
   * Check if method is needed once or always
   * @param elem
   * @returns {boolean}
   * @private
   */
  function _isToggle(elem) {
    return typeof elem.dataset.whenvisibileAlways === 'string';
  }
};
